import * as fromToolActions from '../../../actions/AdmMapa/Eventos/ToolVisible.action';


export interface ToolState {
    ToolActiva: string;
}

const initialStateTool: ToolState = {
    ToolActiva: ''
};

export function ToolVReducer(state = initialStateTool, action: fromToolActions.ActivarToolAction): ToolState {
    switch (action.type) {
        case fromToolActions.ACTIVARTOOL:
            return {
                ...state,
                ToolActiva: action.Tool
            };
      default: {
        return state;
      }
    }
}